module.exports = __webpack_public_path__ + "media/misc/tutorial_icon-2750fe6a.png";